import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetCompanyPoListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    startDate: string | undefined
    endDate: string | undefined
    selectedProject: CustomSingleSelectModel | undefined
    selectedCustomer: CustomSingleSelectModel | undefined
    selectedDivision: CustomSingleSelectModel | undefined
    selectedPo: CustomSingleSelectModel | undefined
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetCompanyPoListPagingAndFilterRequest: GetCompanyPoListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    sortColumn: undefined,
    sortDirection: undefined,
    startDate: undefined,
    endDate: undefined,
    selectedProject: undefined,
    selectedCustomer: undefined,
    selectedDivision: undefined,
    selectedPo: undefined,
    columnFilters: []
}